import { useQuery } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import { QUERY_STALE_TIME } from "utils/constants";
import queryFnEmissionCard from "ApiLayer/Reports/Baseline/queryCurrentAnnualCarbonEmissionsCard";

export const useCurrentAnnualCarbonEmissionsCard = (filtersetUid: string) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: ["currentAnnualCarbonEmissionsCard", filtersetUid],
        queryFn: async () =>
            queryFnEmissionCard(accessToken, {
                reportFiltersetUid: filtersetUid,
            }),
        staleTime: QUERY_STALE_TIME,
    });
};
